import React from 'react';
import type { CountryCode } from '../../config/countries';
import { DATA_SOURCES, capability, sourceBadgeText } from '../../config/products';
import type { DataProductId } from '../../config/products';

export interface SourceBadgeProps {
  country: CountryCode;
  product: DataProductId;
}

/** A small label naming where a product's data comes from; nothing when the source is unconfirmed. */
const SourceBadge: React.FC<SourceBadgeProps> = ({ country, product }) => {
  const text = sourceBadgeText(country, product);
  if (text === null) return null;
  const cap = capability(country, product);
  const summary = cap ? DATA_SOURCES[cap.source].summary : undefined;
  return (
    <span className="badge badge-outline badge-sm" title={summary}>
      {text}
    </span>
  );
};

export default SourceBadge;
